import React, { ReactElement, ReactNode } from 'react'

export type PProps = {
    children: ReactNode
}

/**
 *
 * @param children
 *
 */
const P: React.FC<PProps> = ({ children }: PProps): ReactElement => <p className='para'>{children}</p>

export default P
